import React from 'react';
import ContactForm from '../components/ContactForm';
import GoogleMap from '../components/GoogleMap';
import ScrollToTop from '../components/ScrollToTop';
import { FaUser, FaUsers, FaChartLine, FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Lessons = () => {
  const { t } = useTranslation();

  return (
    <div className="service-page-container">
      <ScrollToTop />
      <header className="service-page-header">
        <h1>{t('lessons.headerTitle')}</h1>
        <p>{t('lessons.headerSubtitle')}</p>
      </header>

      <section className="service-details-section">
        <div className="service-details-content">
          <h2>{t('lessons.headline')}</h2>
          <p className="intro-text">
            {t('lessons.introText')}
          </p>

          <ul className="feature-list">
            <li>
              <div className="feature-icon"><FaUser /></div>
              <div className="feature-text">
                <strong>{t('lessons.privateLessonsTitle')}</strong>
                <span>{t('lessons.privateLessonsDescription')}</span>
              </div>
            </li>
            <li>
              <div className="feature-icon"><FaUsers /></div>
              <div className="feature-text">
                <strong>{t('lessons.groupClinicsTitle')}</strong>
                <span>{t('lessons.groupClinicsDescription')}</span>
              </div>
            </li>
            <li>
              <div className="feature-icon"><FaChartLine /></div>
              <div className="feature-text">
                <strong>{t('lessons.personalizedFeedbackTitle')}</strong>
                <span>{t('lessons.personalizedFeedbackDescription')}</span>
              </div>
            </li>
            <li>
              <div className="feature-icon"><FaStar /></div>
              <div className="feature-text">
                <strong>{t('lessons.allSkillLevelsTitle')}</strong>
                <span>{t('lessons.allSkillLevelsDescription')}</span>
              </div>
            </li>
          </ul>

          <p className="conclusion-text">
            {t('lessons.conclusionText')}
          </p>
        </div>
      </section>

      <ContactForm />
      <GoogleMap />
    </div>
  );
};

export default Lessons;
